import { render, staticRenderFns } from "./SpeakingPhonics1Form.vue?vue&type=template&id=89df9072&"
import script from "./SpeakingPhonics1Form.vue?vue&type=script&lang=js&"
export * from "./SpeakingPhonics1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports